import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { useStores } from 'bringg-web/recipes';

import { ChangeOwnership } from './components/change-ownership';

interface Props {
	alertUuid: string;
	alertOwnerId: number;
}

export const AlertOwnerCell = observer(({ alertUuid, alertOwnerId }: Props) => {
	const {
		usersStore: { currentUser },
		driversStore: { all }
	} = useStores();

	const alertOwner = useMemo(() => {
		if (!alertOwnerId) {
			return null;
		}

		return currentUser?.id === alertOwnerId ? currentUser : all.find(({ id }) => id === alertOwnerId);
	}, [alertOwnerId, all, currentUser]);

	return !alertOwnerId || alertOwnerId === currentUser.id ? (
		<ChangeOwnership alertOwner={alertOwner} alertUuid={alertUuid} />
	) : (
		<span>{alertOwner?.name}</span>
	);
});
